module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-4.8f20101f.jpg";